export const sortingDirection = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
}
